import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  return (
    <section className="section-padding bg-white" data-testid="testimonials-section">
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-[#00e5ff] mb-3 block">
            Testimonials
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#212121] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="testimonials-headline"
          >
            What Our Clients Say
          </h2>
        </motion.div>

        {/* Coming Soon Placeholder */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="max-w-2xl mx-auto mt-12"
        >
          <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl border border-dashed border-slate-200 p-8 md:p-12 text-center">
            <div className="w-16 h-16 rounded-full bg-[#00e5ff]/10 flex items-center justify-center mx-auto mb-6">
              <Quote className="w-8 h-8 text-[#1a237e]" />
            </div>
            <h3
              className="text-xl md:text-2xl font-semibold text-[#212121] mb-3"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Coming Soon
            </h3>
            <p className="text-[#5a6b8c]">
              We're working with our first batch of clients. Their success stories will appear here soon!
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
